import axios from 'axios'
import store from '@/store'
import router from '@/router'

// Evita el loop de redirecciones cuando ya estamos en login
function isOnLoginRoute() {
  const current = router.currentRoute
  if (!current) return false
  return current.name === 'login' || current.path === '/'
}

function handleSessionInvalid() {
  // Limpiar store
  store.commit('setData', {
    token: '',
    username: '',
    role: '',
    expiresIn: '',
    isAuthenticated: false,
  })

  // Redirigir al login solo si no estamos ya allí
  if (!isOnLoginRoute()) {
    router.push('/').catch(() => {})
  }
}

export default () => {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'https://sandbox.habi.complement-it.com/api/',
    // 10 minutos: suficiente para SPs pesados como sp_ecp_informacion_consol,
    // pero sin dejar la petición colgada indefinidamente si el backend muere.
    timeout: 600000,
  })

  instance.interceptors.request.use(
    (config) => {
      const token = store.state.token
      if (token) {
        config.headers = config.headers || {}
        config.headers.Authorization = `Bearer ${token}`
      } else {
        delete config.headers.Authorization
      }
      return config
    },
    (error) => Promise.reject(error)
  )

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response && error.response.status
      const data = error.response && error.response.data

      if (
        status === 401 &&
        (
          (data && data.valid === false) ||
          (data && (data.reason === 'session_closed' || data.reason === 'no_token'))
        )
      ) {
        handleSessionInvalid()
      }

      if (status === 401 && !isOnLoginRoute()) {
        if (store.state.token && !store.state.isAuthenticated) {
          handleSessionInvalid()
        }
      }

      return Promise.reject(error)
    }
  )

  return instance
}
